module.exports = __webpack_public_path__ + "static/img/Tela de contas a receber.bf59f7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Screenshots/Tela de contas a receber.png
// module id = O7OX
// module chunks = 0